// extracted by mini-css-extract-plugin
module.exports = {"datum":"styles_datum___M9nV","headerContent":"styles_headerContent__2LzxC","detailsSidebarContentContainer":"styles_detailsSidebarContentContainer__33deS"};